import React, { useContext } from 'react';
import { useAuth } from 'react-oidc-context';
import WatchlistTable from '../components/WatchlistTable';
import { FinancialRatiosExplanation } from '../components/FinancialRatioStatus';
import { WatchlistContext } from '../contexts/StockWatchlistContext';
import { useLatestFinancialRatios } from '../hooks/useLatestFinancialRatios';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { METRIC_FIELDS } from '../constants/metricFields';
import './StockWatchlist.css';

const DEFAULT_METRIC_KEYS = ['priceToEarningsRatio', 'grossProfitMargin', 'netProfitMargin'];
const DEFAULT_METRICS = METRIC_FIELDS
  .filter(metric => DEFAULT_METRIC_KEYS.includes(metric.value))
  .map(metric => ({ label: metric.label, key: metric.value }));

export default function StockWatchlist() {
  const auth = useAuth();
  const { symbols: watchlistStocks, remove: removeFromWatchlist } = useContext(WatchlistContext);
  const { results } = useLatestFinancialRatios(watchlistStocks);
  const [selectedMetrics, setSelectedMetrics] = useLocalStorage('watchlistSelectedMetrics', DEFAULT_METRICS);

  return (
    <div className="stock-watchlist-page">
      <h2>Stock Watchlist</h2>
      <FinancialRatiosExplanation />
      {!auth.isAuthenticated && (
        <div className="login-cta">
          <p>Sign Up or Log In here to save your watchlist.</p>
          <button
            onClick={() => {
              sessionStorage.setItem('pendingSave', JSON.stringify(watchlistStocks));
              sessionStorage.setItem('postLoginRedirect', '/watchlist');
              auth.signinRedirect();
            }}
            className="cta-button"
          >
            Sign In Here to Save Watchlist
          </button>
        </div>
      )}
      {watchlistStocks.length > 0 ? (
        <WatchlistTable
          watchlistStocks={watchlistStocks}
          results={results}
          selectedMetrics={selectedMetrics}
          setSelectedMetrics={setSelectedMetrics}
          removeFromWatchlist={removeFromWatchlist}
        />
      ) : (
        <div className="empty-watchlist">
          <p>Your watchlist is empty. Search and add stocks above.</p>
        </div>
      )}
    </div>
  );
}
